import { Injectable } from '@angular/core';
import { AppDataService } from 'app/services/app.data.service';
import { XpressUserService } from 'app/services/xpress-user.service';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class AuthInitializerService {
    constructor(
        private appDataService: AppDataService,
        private xpressUserService: XpressUserService,
        private messageService: MessageService
    ) {}

    async initialize(): Promise<boolean> {
        try {
            // Check authentication
            const xpressAuth = localStorage.getItem('xpressAuth') ?? sessionStorage.getItem('xpressAuth');

            if (!xpressAuth) {
                this.appDataService.setAuthDataLoaded(true);
                return true;
            }

            const localStorageAuthData = JSON.parse(xpressAuth);
            const expDateUtc = localStorageAuthData['.expires'];
            const expirationDate = new Date(`${expDateUtc}Z`);

			// If session is expired
            if (new Date() >= expirationDate) {
                this.appDataService.setAuthDataLoaded(true);
                return true;
            }

            // Set access_token from localStorage
            this.appDataService.authData.access_token = localStorageAuthData.access_token;

            // Get AuthData from server by token
            const data = await this.xpressUserService.getAuthData(this.messageService);

            if (!data || !data.Success) {
                this.appDataService.setAuthDataLoaded(true);
                return true;
            }

            this.appDataService.authData = data;
            this.appDataService.authData.access_token = localStorageAuthData.access_token;
            if (data.roleId != null && data.roleId !== '') {
                this.appDataService.xpressUserRoleId = +data.roleId;
            }
            this.appDataService.setAuthDataLoaded(true);
            return true;
        } catch (error) {
            this.appDataService.setAuthDataLoaded(true);
            return true;
        }
    }
}
export class AuthInitializerFactory {
    static createInitializer(authInitializer: AuthInitializerService): () => Promise<any> {
        return () => authInitializer.initialize();
    }
}
